function About() {
  return (
    <section className="home-page">
      <div className="home-content">
        <h1>About</h1>
        <p>
          Aplikacja powstała z pasji do sektora energetycznego i jako rozszerzenie bloga{' '}
          <a href="https://res-whisper.com/" target="_blank" rel="noreferrer">
            res-whisper.com
          </a>
          , na którym opisujemy rynek energii w USA. Chcemy wspierać rozwój odnawialnych
          źródeł energii poprzez ich integrację z magazynami energii, pomagając
          równoważyć polski rynek energetyczny i maksymalizować zyski z instalacji
          fotowoltaicznych.
        </p>
      </div>
    </section>
  );
}

export default About;
